import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.5_@biomejs+biome@2.0.6_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node_0931811aa2e553d006423ed14fce9b07/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}